module.exports = __webpack_public_path__ + "static/img/about-step4.48f2ccf7.png";